import { axios } from '$app-web/api/axios';

import { Endpoints } from '../constant';

export async function verifyPhoneCode(phone: string, verificationCode: string) {
    try {
        const payload = { phone, verification_code: verificationCode };

        const { status } = await axios.post(Endpoints.User.Phone, payload);

        return status === 200;
    } catch (error) {
        return false;
    }
}
